import {compact, filter} from 'lodash';
import {FormProvider, useForm} from 'react-hook-form';

import FormCombobox from 'components/form/Combobox';
import FormSubmit from 'components/form/Submit';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';

export default function StatsForm({techStacks, onSave}) {
  const appContext = useAppContext();

  const languageOptions = filter(techStacks, (techStack) => techStack.category === 'LANGUAGE');
  const frontEndOptions = filter(techStacks, (techStack) => techStack.category === 'FRONTEND');
  const backendOptions = filter(techStacks, (techStack) => techStack.category === 'BACKEND');
  const databaseOptions = filter(techStacks, (techStack) => techStack.category === 'DATABASE');
  const devOpsOptions = filter(techStacks, (techStack) => techStack.category === 'DEVOPS');


  const formMethods = useForm({
    defaultValues: {
      userId: '',
      techStackNames: [],
    },
  });

  const {handleSubmit, setError} = formMethods;
  
  const onSubmit = async (values) => {
    try {
      const data = [
        values?.language?.value,
        values?.frontend?.value,
        values?.backend?.value,
        values?.database?.value,
        values?.devOps?.value,
      ];

      const rez = await appContext.api.post('api/v1/userTechStacks/search', {
        json: {
          userId: values?.userId,
          techStackNames: compact(data),
        },
        parseJson: true,
      });
      onSave(rez);
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };

  
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input">
          <FormCombobox label="Language" name="language" options={languageOptions} isMulti={false} required={true} />
        </div>
        <div className="input">
          <FormCombobox label="Frontend" name="frontend" options={frontEndOptions} isMulti={false} required={true} />
        </div>
        <div className="input">
          <FormCombobox label="Backend" name="backend" options={backendOptions} isMulti={false} required={true} />
        </div>
        <div className="input">
          <FormCombobox label="Database" name="database" options={databaseOptions} isMulti={false} />
        </div>
        <div className="input">
          <FormCombobox label="DevOps" name="devOps" options={devOpsOptions} isMulti={false} />
        </div>
        <div className="input input--topPad">
          <FormSubmit>Go</FormSubmit>
        </div>
      </form>
    </FormProvider>
  );
}
